export * from './get';

/**
 * Tags that will be dynamically fetched Data from the API
 */
export const DYNAMIC_PLAYER_TAG_ID = 'playerIdTags';
